const ContactBar = () => {
  return (
    <section className="py-16 bg-accent">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center text-white">
          {/* Phone */}
          <div className="flex flex-col items-center gap-4">
            <div className="w-16 h-16 flex items-center justify-center bg-secondary rounded-full">
              <i className="ri-phone-line text-3xl"></i>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">اتصل بنا</h3>
              <a
                href="tel:+966512345678"
                className="text-lg text-gray-300 hover:text-secondary transition-colors cursor-pointer"
              >
                +966 51 234 5678
              </a>
            </div>
          </div>

          {/* WhatsApp */}
          <div className="flex flex-col items-center gap-4">
            <div className="w-16 h-16 flex items-center justify-center bg-secondary rounded-full">
              <i className="ri-whatsapp-line text-3xl"></i>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">واتساب</h3>
              <a
                href="https://wa.me/966512345678"
                target="_blank"
                rel="noopener noreferrer"
                className="text-lg text-gray-300 hover:text-secondary transition-colors cursor-pointer"
              >
                تواصل عبر واتساب
              </a>
            </div>
          </div>

          {/* Location */}
          <div className="flex flex-col items-center gap-4">
            <div className="w-16 h-16 flex items-center justify-center bg-secondary rounded-full">
              <i className="ri-map-pin-line text-3xl"></i>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">موقعنا</h3>
              <p className="text-lg text-gray-300">
                المملكة العربية السعودية
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactBar;